var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCleanupNavIcon = function SvgCleanupNavIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8C2E89",
    d: "M12.43.02a.5.5 0 0 0-.53.53l.4 6.76a1 1 0 0 0 1.7.64l1.15-1.15 3.02 3.02a1 1 0 0 0 1.41 0L21.7 7.7a1 1 0 0 0 0-1.41l-3-3.02 1.14-1.15a1 1 0 0 0-.65-1.7l-6.75-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AA2C4",
    d: "M3.31 18.73.3 15.71a1 1 0 0 1 0-1.41l2.12-2.12a1 1 0 0 1 1.41 0l3.02 3.02L8 14.05a1 1 0 0 1 1.7.64l.4 6.76a.5.5 0 0 1-.53.53l-6.75-.4a1 1 0 0 1-.65-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBD15D",
    d: "M21.98 12.43a.5.5 0 0 0-.53-.53l-6.76.4a1 1 0 0 0-.64 1.7l1.15 1.15-3.02 3.02a1 1 0 0 0 0 1.41l2.12 2.12a1 1 0 0 0 1.41 0l3.02-3.01 1.15 1.14a1 1 0 0 0 1.7-.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA3556",
    d: "M3.27 3.31 6.29.3A1 1 0 0 1 7.7.3l2.12 2.12a1 1 0 0 1 0 1.41L6.8 6.85 7.95 8a1 1 0 0 1-.64 1.7l-6.76.4a.5.5 0 0 1-.53-.53l.4-6.75a1 1 0 0 1 1.7-.65L3.27 3.3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export default SvgCleanupNavIcon;